import React from 'react';
import { Tooltip } from "antd"

const DisabledPoolInfo = (props) => {
    if(props.visible){  
        return <Tooltip
            overlayClassName='secondary'
            title={'Some or all of selected funds are earmarked for another transaction. Select another pool for an exchange.'}>
            {props.children}
        </Tooltip>
    }
    return props.children
}

export default DisabledPoolInfo;